export default {
  isLoggedIn(state) {
    return state.user_connected_id != null;
  },
  fullWidth(state) {
    return state.full_width;
  },
  curr(state) {
    return state.test_count;
  }
}
